import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { hideNotification } from '../../store/actions/notification';
import DashboardLayout from './../layout/Dashboard';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { getOrderApi } from '../../api/orders/orders';
import { OrderDetailsComponent } from '../../components/pages/orderManagement/OrderDetailsComponent';
import { Messages } from "../../components/layout/Messages/Messages";
import { ResendInvoice } from '../../components/pages/orderManagement/actionButtons/ResendInvoice';
import { NOTIFICATION_ORDER_ACTIONS } from '../../config/notifications';
import { ACL, PAGE_CONTEXTS, TRANSLATED_ORDER_STATUSES } from '../../config/constants';
import { NoRights } from '../../components/layout/Permissions/NoRights';
import {
  CancelOrder
} from '../../components/pages/orderManagement/actionButtons/CancelOrder';
import { history } from '../../store/configureStore';
import { ROUTE_CLIENT_ORDERS } from '../../config/routes';
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './View.scss';


function OrderViewComponent(props) {
  const [ orderID, setOrderID ] = useState( null );
  const [ order, setOrder ] = useState( null );

  useEffect( () => {
    const { id } = props.match.params;
    setOrderID( id );
  }, [] ); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect( () => {
    if (orderID) {
      getOrder( orderID );
    }
  }, [ orderID ] );

  const getOrder = (id) => {
    if (! ACL.CLIENT.ORDERS.VIEW.hasAccess()) {
      return;
    }

    getOrderApi( {
      id: id,
      pagination: {
        page_context: PAGE_CONTEXTS.ORDERS.VIEW,
      }
    } ).then( response => {
      if (! response || ! response.data) {
        return;
      }

      setOrder( response.data );
    } );
  };

  const hasNoPageRights = ! ACL.CLIENT.ORDERS.VIEW.hasAccess();
  const pageHeader = (
    <PageHeader
      actions={order?.id ? (
        <>
          <ResendInvoice
            index={0}
            order={order}
          />
          <CancelOrder
            index={0}
            order={order}
            actionCallback={() => history.push( ROUTE_CLIENT_ORDERS )}
          />
        </>
      ) : null}
      breadcrumbs={order ? (
        <Link
          className="order-detail-back-link"
          onClick={() => {history.goBack()}}
          to=''
        >
          <i aria-hidden="true" className="fa fa-arrow-left"/>
          <FormattedMessage id="messages.go_back"/>
        </Link>
      ) : null}
      status={order?.id ? (
        <span className="order-detail-status">
          <span aria-hidden="true" className="order-detail-status__dot"/>
          {TRANSLATED_ORDER_STATUSES[order.status]}
        </span>
      ) : null}
      title={(
        <>
          <FormattedMessage id="pages.orderManagement.viewOrder.title"/>
          <span>{order?.order_number ? `: ${order.order_number}` : ':'}</span>
        </>
      )}
    />
  );

  return (
    <DashboardLayout
      className="view-order"
      pageTitle={<FormattedMessage id="app.dashboard.page_title"/>}
      workspace
      {...props}
    >
      <PageWorkspace className="order-detail-workspace">
        <div className="order-detail-notifications">
          <Messages/>
          <Messages notificationId={NOTIFICATION_ORDER_ACTIONS}/>
        </div>
        {hasNoPageRights ? (
          <>
            {pageHeader}
            <PageSurface className="order-detail-no-rights">
              <NoRights/>
            </PageSurface>
          </>
        ) : order ? (
          <OrderDetailsComponent
            header={pageHeader}
            item={order}
            location={props.location}
          />
        ) : pageHeader}
      </PageWorkspace>
    </DashboardLayout>
  );
};

const mapActionsToProps = {
  hideNotification
};

const OrderView = connect( null, mapActionsToProps )( OrderViewComponent );

export { OrderView, OrderViewComponent };
